import { wrapReducer } from "@client/content/lib/helper";
import { type FailureActionData } from "@client/lib/actions";
import { Status } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import {
  Actions,
  type GetBeginActionData,
  type GetSuccessActionData,
  type InitActionSuccessData,
  type ProgressBeginActionData,
  type ProgressSuccessActionData
} from "./actions";
import { type Form } from "./types";

const reducer = (state: Form.AppState, action: ReduxAction<any>): Form.AppState => {
  switch (action.type) {
    case Actions.InitBegin: {
      return {
        ...state,
        status: Status.Loading
      };
    }
    case Actions.InitFailure: {
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        error,
        status: Status.Failed
      };
    }
    case Actions.InitSuccess: {
      const { emailFieldId } = action.data as InitActionSuccessData;
      return {
        ...state,
        emailFieldId,
        status: Status.Ready
      };
    }

    case Actions.GetBegin: {
      const { formId } = action.params as GetBeginActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [formId]: {
            error: null,
            form: null,
            status: Status.Loading
          }
        }
      };
    }
    case Actions.GetFailure: {
      const { formId } = action.params as GetBeginActionData;
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [formId]: {
            error,
            form: null,
            status: Status.Failed
          }
        }
      };
    }
    case Actions.GetSuccess: {
      const { formId } = action.params as GetBeginActionData;
      const { data, email, mustEnter } = action.data as GetSuccessActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [formId]: {
            error: null,
            form: data,
            status: Status.Ready
          }
        },
        email,
        mustEnter
      };
    }

    case Actions.ProgressBegin: {
      const { formId } = action.params as ProgressBeginActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [formId]: {
            ...state.detail[formId],
            status: Status.Saving
          }
        }
      };
    }
    case Actions.ProgressFailure: {
      const { formId } = action.params as ProgressBeginActionData;
      const { error } = action.data as FailureActionData;
      return {
        ...state,
        detail: {
          ...state.detail,
          [formId]: {
            ...state.detail[formId],
            error,
            status: Status.Failed
          }
        }
      };
    }
    case Actions.ProgressSuccess: {
      const { email } = action.data as ProgressSuccessActionData;
      return {
        ...state,
        email
      };
    }
    default:
      return state;
  }
};

export const defaultState: Form.AppState = {
  detail: {},
  emailFieldId: "",
  email: null,
  error: null,
  mustEnter: false,
  id: "",
  status: Status.None
};
export const previewState: Form.AppState = {
  detail: {},
  emailFieldId: "",
  email: null,
  error: null,
  mustEnter: false,
  id: "",
  status: Status.Ready
};
export default wrapReducer<Form.AppState>({ defaultState, reducer, previewState });
